import React, {Fragment} from 'react'
import Config from '../launch/config'
import UnknownContent from './unknown-content'

import './css/towable-info.css'

const TowableInfo = ({towable}) => {
    if (!towable) {
        return null
    }

    const {faction, isDiscovered, type} = towable

    if (!isDiscovered || type === 'default') {
        return <UnknownContent />
    }

    let imgName = 'artifact'

    if (faction?.includes(Config.enemyFactionName)) {
        imgName += '-red'
    }

    if (faction === Config.userFactionName) {
        imgName += '-green'
    }

    return (
        <Fragment>
            <div className="towable-info__preview">
                <img
                    alt="artifact"
                    className="towable-info__preview-img"
                    src={`${process.env.PUBLIC_URL}/img/${imgName}.png`}
                />
            </div>
            <div className="towable-info__description">
                <h1 className="modal-heading">Artifact</h1>
                <p>A shiny object of unknown origin.</p>
                {!faction && (
                    <p>
                        Bring this artifact into orbit of a colonized planet to
                        collect it.
                    </p>
                )}

                {faction?.includes(Config.enemyFactionName) && (
                    <p
                        className={`artifact__status-row ${Config.enemyFactionName}`}
                    >
                        <img
                            alt="close"
                            className="artifact__status-icon"
                            src={`${process.env.PUBLIC_URL}/img/close-red.png`}
                        />
                        Enemy Controlled
                    </p>
                )}
                {faction === Config.userFactionName && (
                    <p
                        className={`artifact__status-row ${Config.userFactionName}`}
                    >
                        <img
                            alt="check"
                            className="artifact__status-icon"
                            src={`${process.env.PUBLIC_URL}/img/check-green.png`}
                        />
                        Collected
                    </p>
                )}
            </div>
        </Fragment>
    )
}

export default TowableInfo
